/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React, { Children } from 'react';
import PropTypes from 'prop-types';

var SidePanelContent = function SidePanelContent(_ref) {
  var activePanelId = _ref.activePanelId,
    children = _ref.children,
    cloneNavProps = _ref.cloneNavProps,
    nextId = _ref.nextId,
    previousId = _ref.previousId,
    setActivePanelById = _ref.setActivePanelById;
  return /*#__PURE__*/React.createElement("div", {
    className: "cpc--side-panel__body-content"
  }, Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && children.props && cloneNavProps ? /*#__PURE__*/React.cloneElement(children, {
    setActivePanelById: setActivePanelById,
    previousPanelId: previousId,
    activePanelId: activePanelId,
    nextPanelId: nextId
  }) : children);
};
SidePanelContent.propTypes = {
  activePanelId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  cloneNavProps: PropTypes.bool.isRequired,
  nextId: PropTypes.string,
  previousId: PropTypes.string,
  setActivePanelById: PropTypes.func.isRequired
};
var SidePanelContent$1 = SidePanelContent;

export { SidePanelContent$1 as default };
